import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

export interface DuplicateFebDialogData {
  febLabel?: string | null;
  febNumber?: string | null;
}

@Component({
  selector: 'app-duplicate-feb-dialog',
  templateUrl: './duplicate-feb-dialog.component.html',
  styleUrls: ['./duplicate-feb-dialog.component.less']
})
export class DuplicateFebDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<DuplicateFebDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: DuplicateFebDialogData
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}